import React, { useState, useEffect, useRef } from 'react';
import Uploader from './Uploader/Uploader';
import PropTypes from 'prop-types';
import ExistingImage from './ExistingImage';
import SelectMediaType from './SelectMediaType/SelectMediaType';
import { addUploader, removeUploader } from '../../helpers/uploadsHelper';

const uploadsArray = [];

function EditMedia(props) {
  const { uploadedMedia, allowImages, allowVideo, hasMediaError, hasYouTubeError } = props;
  const [mediaType, setMediaType] = useState('none');  
  let canUpload = useRef(false); //used to determine if there is an uploader with no file uploaded yet
  const [latestUploader, setLatestUploader] = useState('');
  const hasUploadedMedia = uploadedMedia?.length > 0;
  const uploadedMediaIsImage = uploadedMedia[0]?.mediaTypeId === 1;
  const uploadedMediaIsVideo = uploadedMedia[0]?.mediaTypeId === 4;

  if (mediaType === "video" && uploadsArray.length) {
    const existingMediaOnly = uploadsArray.filter(uploader => uploader.props.uploadedMedia);
    uploadsArray.length = 0;
    uploadsArray.push(...existingMediaOnly);

    if (uploadsArray.length < 4) {
      uploadsArray.push(<Uploader key={crypto.randomUUID()} uploaderCount={uploadsArray.length+1} instanceNumber={crypto.randomUUID()} handleCallback={updateUploaderArray}/>);
    }
  } 

  useEffect(() => {
    // Check the first media item uploaded to see what type of media was previously uploaded
    switch (true) {
      case hasUploadedMedia && uploadedMediaIsImage:
        setMediaType('image');
        break;
      case hasUploadedMedia && uploadedMediaIsVideo:
        setMediaType('video');
        break;
      case allowImages && !allowVideo:
        setMediaType('image');
        break;
      case allowVideo && !allowImages:
        setMediaType('video');
        break;
      default:
        setMediaType('none');
    }
  }, [uploadedMedia, allowVideo, allowImages, hasUploadedMedia, uploadedMediaIsImage, uploadedMediaIsVideo]);

  useEffect(() => {
    uploadsArray.length = 0;
    // Add the existing images to the page for each uploaded media item, otherwise add a blank uploader to the page
    if (hasUploadedMedia && uploadedMediaIsImage && uploadedMedia.length) {
      for(const upload of uploadedMedia) {
        uploadsArray.push(      
          <ExistingImage
            key={crypto.randomUUID()}
            uploadedMedia={upload}
            instanceNumber={crypto.randomUUID()}
            allowImages={allowImages}
            handleCallback={updateUploaderArray}/>
        );
      }
    }

    if (uploadsArray.length < 4) {
      uploadsArray.push(<Uploader key={crypto.randomUUID()} uploaderCount={uploadsArray.length+1} instanceNumber={crypto.randomUUID()} handleCallback={updateUploaderArray}/>);
      canUpload.current = true;
    }
  },[]);

  function updateUploaderArray(instanceNumber = null) {
    if (!removeUploader(instanceNumber, uploadsArray)) {
      //not removing so a file must have just been uploaded
      canUpload.current = false;
    }
    
    //if there are not 4 uploaders then add a new one and set latestUploader to re-render the component
    if (uploadsArray.length < 4) {
      //if there is already an uploader that doesn't have an upload remove it before adding a new one
      const removeLast = instanceNumber != null && canUpload.current;
      const newInstanceNumber = addUploader(uploadsArray, removeLast, updateUploaderArray);
      setLatestUploader(newInstanceNumber); //trigger a re-render
      canUpload.current = true;
    }
  }

  return (
    <SelectMediaType
      hasMediaError={hasMediaError}
      hasYouTubeError={hasYouTubeError}
      allowImages={allowImages}
      allowVideo={allowVideo}
      mediaType={mediaType}
      setMediaType={setMediaType}
      uploadedMedia={uploadedMedia}
      uploadedMediaIsImage={uploadedMediaIsImage}
      uploadedMediaIsVideo={uploadedMediaIsVideo}
      imageUploaders={uploadsArray}/>
  )
}

EditMedia.propTypes = {
  id: PropTypes.number,
  externalId: PropTypes.string,
};

export default EditMedia;
